// Generated by tools/generate-syrian-location-names.cjs from public/data/syria-cities.geojson.
export const LOCATION_NAMES: Readonly<Record<string, string>> = {
  "ابو كمال": "Albu Kamal",
  "ادلب": "Idlib",
  "ارض خربة كفر موسي": "Kafr Musa Al-Hmidiya",
  "ازرع": "Izra'",
  "اعزاز": "I'zaz",
  "افس": "Afis",
  "اقويران": "Aqwiran",
  "الباب": "Al Bab",
  "التل": "At Tall",
  "الثورة": "Al-Tabqa",
  "الحراك": "Al Hirak",
  "الحولة‎‎": "Kafr Laha",
  "الدانا": "Ad Dana",
  "الدرباسية": "Ad Darbasiyah",
  "الدريكيش": "Ad Duraykish",
  "الرستن": "Ar Rastan",
  "الرقة": "Ar Raqqah",
  "الزبداني": "Az Zabadani",
  "الزيتية": "Kafr Zayta",
  "السفيرة": "As Safirah",
  "السلمية": "As Salamiyah",
  "السوسة": "As Susah",
  "السويداء": "As-Suwayda",
  "الشيخ مسكين": "Shaykh Miskin",
  "الصنمين": "As Sanamayn",
  "الغانية": "Kafr Buhum",
  "الغنطو": "Al Ghantu",
  "القريتين": "Al Qaryatayn",
  "القصير": "Al Qusayr",
  "القطيفة": "Al Qutayfah",
  "القنيطرة": "Al Qunaytirah",
  "الكرمة": "Maharda",
  "الكسوة": "Al Kiswah",
  "المخرم الفوقاني": "Mukharram al Fawqani",
  "الميادين": "Al Mayadin",
  "النبك": "An Nabk",
  "ام الصفا": "Umm as Safa",
  "انخل": "Inkhil",
  "ايوبية": "Ayyubiyah",
  "باتبو": "Batabo",
  "بانياس": "Baniyas",
  "برج اسلام": "Burj Islam",
  "برج صافيتا": "Safita",
  "بصري": "Busra ash Sham",
  "بقعاتا": "Buq'ata",
  "بنش": "Binnish",
  "تادف": "Tadif",
  "تدمر": "Tadmur",
  "تل رفعت": "Tall Rif'at",
  "تل كلخ": "Tallkalakh",
  "تلبيسة": "Tallbisah",
  "جاسم": "Jasim",
  "جبلة": "Jablah",
  "جديدة": "Judaydat Yabus",
  "جرابلس": "Jarabulus",
  "جسر الشغور": "Jisr ash Shughur",
  "جنديرس": "Jindayris",
  "جنية": "Jinniyah",
  "جيرود": "Jayrud",
  "حرستا": "Harasta",
  "حلب": "Aleppo",
  "حلفايا": "Halfaya",
  "حماة": "Hamah",
  "حمص": "Homs",
  "خان شيخون": "Khan Shaykhun",
  "خربة الذبابير": "Khirbat adh Dhababir",
  "خربة السودة": "Qabbasin",
  "خربة الشياب": "Khirbat ash Shiyab",
  "د مشق": "Damascus",
  "داريا": "Darayya",
  "دژ كردان": "Qal`at al Hisn",
  "دوما": "Duma",
  "دير الزور": "Deir ez-Zor",
  "دير العصافير": "Dayr al 'Asafir",
  "دير حافر": "Dayr Hafir",
  "سبيخان": "Subaykhan",
  "سراقب": "Saraqib",
  "سلامين": "Lislamin",
  "سلقين": "Salqin",
  "سلمان": "Salman",
  "شطحة": "Shathah",
  "شهبا": "Shahba",
  "صلاخد": "Salakhid",
  "صوران": "Suran",
  "طاوي": "Altala",
  "طرطوس": "Tartus",
  "طفس": "Tafas",
  "طيبة الامام": "Tayyibat al Imam",
  "عامودا": "'Amuda",
  "عرب بينار": "'Ayn al 'Arab",
  "عربين": "'Irbin",
  "عفرين": "'Afrin",
  "فلاح ربو": "Flaleh",
  "قارة": "Qarah",
  "قباسين": "Kabbasin",
  "قصر البنات": "Qasr al Banat",
  "قطنا": "Qatana",
  "كاف الجاع": "Kaff al-Jaa",
  "كفر تخاريم": "Kafr Takharim",
  "كفر نبل": "Kafranbel",
  "كفرصغير": "Kafr Saghir",
  "كوجوك كوي": "Kujuk Kuy",
  "مدنة صغيرة": "Madanah Saghir",
  "مدنة كبير": "Madanah Kabir",
  "مصياف": "Masyaf",
  "معرة مصرين": "Ma'arratmisrin",
  "معلولا": "Ma'lula",
  "معيصرة": "Mu'aysirah",
  "منبج": "Manbij",
  "مورك": "Murak",
  "نبل": "Nubl",
  "هجين": "Hajin",
  "وديرة": "Wuraydah",
  "يبرود": "Yabrud"
};
